import { render, staticRenderFns } from "./SugiInfo.vue?vue&type=template&id=459bef3e"
import script from "./SugiInfo.vue?vue&type=script&lang=js"
export * from "./SugiInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports